import React from "react";
import "./error.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";

interface Props {
    title: string;
    message: string;
}

export const CatalogSearchResultError: React.FC<Props> = ({title, message}) => {

    const {t} = useTranslation('translation', {useSuspense: false});

    return (
        <div className={"catalog-error"}>
            <div className={"catalog-error-icon"}>
                <FontAwesomeIcon icon={["fas", "search"]}/>
            </div>
            <div className={"catalog-error-title"}>
                {t(title)}
            </div>
            <div className={"catalog-error-message"}>
                {t(message)}
            </div>
        </div>
    )
}